<template>
  <div>
    <other-banner :BannerType="'产品中心'"></other-banner>
    <div class="content_box">
      <div class="search">
         <div class="search_box">
           <div class="input">
             <img src="../../assets/product/search.png">
             <input @keydown.enter='goSearch' v-model="name" placeholder="请输入关键词" />
           </div>
           <div class="searcH_box" @click="goSearch">搜索</div>
         </div>
       </div>
      <div class="crumbs" v-if="$route.meta.cate!='detais' && $route.meta.cate!='search'"><span style="color: #666666">当前位置：产品中心></span> {{ $route.name }}</div>

      <div class="title" v-if="$route.meta.cate!='detais' && $route.meta.cate!='search'">
         <title-nav :zhName="$route.name" :enName="$route.meta.cate"></title-nav>
      </div>
      <router-view ref="progressTwo" />
    </div>
  </div>

</template>

<script>
import OtherBanner from "../../components/otherBanner";
import TitleNav from "../../components/titleNav";
export default {
  name: "product",
  components: {TitleNav, OtherBanner},
  data(){
    return{
      name:''
    }
  },
  created() {
    if(this.$route.query.name){
      this.name = this.$route.query.name
    }
  },
  methods:{
    goSearch(){
      if(this.$route.name=='产品详情'){
        this.$router.push({path:'/product/produceSearch',query:{name:this.name,cate_name:'品牌产品',group_id:this.$refs.progressTwo.ProductInfo.group_id}})
      }else if(this.$route.name=='产品搜索'){
        this.$router.push({path:'/product/produceSearch',query:{name:this.name,cate_name:this.$route.query.cate_name,group_id:this.$route.query.group_id}})
      }else {
        this.$router.push({path:'/product/produceSearch',query:{name:this.name,cate_name:this.$route.name,group_id:this.$refs.progressTwo.group_id}})
      }

    },
  }

}
</script>

<style scoped lang="less">
   .content_box{
     width: 1200px;
     margin: 0 auto;
     cursor: pointer;
     .search{
       height: 133px;
       background: #FFFFFF;
       box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
       .search_box{
         padding: 34px 186px;
         display: flex;
         align-items: center;
         justify-content: space-between;
         .input{
           width: 732px;
           height: 65px;
           background: #F5F5F5;
           img{
             width: 25px;
             height: 25px;
             margin-left:40px;
             transform:translateY(6px);
           }
           input{
             height: 100%;
             border: none;
             background: #F5F5F5;
             width: 80%;
             margin-left: 25px;
             font-size: 18px;
             font-family: Microsoft YaHei;
             font-weight: 400;
             color: #C2C2C2;
           }
         }
         .searcH_box{
           font-size: 18px;
           font-family: Microsoft YaHei;
           font-weight: 400;
           color: #0092DD;
         }
       }
     }
     .crumbs{
        padding: 30px 0 15px;
       border-bottom: 1px solid #DBDBDB;
       font-size: 18px;
       font-family: Microsoft YaHei;
       font-weight: 400;
       color: #0092DD;
       opacity: 1;
     }
     .title{
       margin: 70px auto 60px;
     }
   }
   @media (max-width: 1200px) {
     .content_box{
       width: auto;
       padding:0.1px 15px 0;
       .search{
         margin-top:-9px;
         height: 67px;
         position: relative;
         z-index: 1;
         background: #FFFFFF;
         box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
         .search_box{
           padding: 19px 17px;
           .input{
             width: 90%;

             height: 33px;
             background: #F5F5F5;
             img{
               width: 17px;
               height: 17px;
               margin-left:18px;
               transform:translateY(4px);
             }
             input{
               height: 100%;
               border: none;
               background: #F5F5F5;
               width: 80%;
               margin-left:10px;
               font-size: 10px;
               font-family: Microsoft YaHei;
               font-weight: 400;
               color: #C2C2C2;
             }
           }
           .searcH_box{
             font-size: 11px;
             font-family: Microsoft YaHei;
             font-weight: 400;
             color: #0092DD;
           }
         }
       }
       .crumbs{
         padding: 15px 0 7px;
         border-bottom: 1px solid #DBDBDB;
         font-size: 10px;
         font-family: Microsoft YaHei;
         font-weight: 400;
         color: #0092DD;
         opacity: 1;
       }
       .title{
         margin: 20px auto 15px;
       }
     }
   }
</style>